module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container\"> <div class=\"section-margin-lg\"> <div class=\"row\"> <div class=\"col-sm-6 col-md-5 col-sm-push-6 col-md-push-6 right-panel\"> <div class=\"row\"> <div class=\"col-xs-10 col-xs-offset-1 text-center\"> <h4>Already have an account?</h4> <a class=\"btn btn-blue btn-lg btn-block\" href=\"/signin\">Log In</a> </div> </div> </div> <div class=\"col-sm-6 col-md-5 col-md-offset-1 col-sm-pull-6 col-md-pull-5 left-panel\"> <div class=\"row\"> <div class=\"col-xs-10 col-xs-offset-1\"> <h3>Create Free Account</h3> <form id=\"user_create_form\"> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-name\" name=\"user[name]\" placeholder=\"First & Last Name\" size=\"30\" type=\"text\" value=\"")
    ; __append(escapeFn( locals.name ))
    ; __append("\"> </div> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-email\" name=\"user[email]\" placeholder=\"Email Address\" size=\"30\" type=\"email\" value=\"")
    ; __append(escapeFn( locals.email ))
    ; __append("\"> </div> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-phone_number\" name=\"user[phone_number]\" placeholder=\"Phone Number\" size=\"30\" type=\"text\" value=\"")
    ; __append(escapeFn( locals.phone_number ))
    ; __append("\"> </div> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-password\" name=\"user[password]\" placeholder=\"Password\" size=\"30\" type=\"password\"> </div> <div class=\"form-group\"> <input class=\"form-control\" id=\"signup-password_confirmation\" name=\"user[password_confirmation]\" placeholder=\"Confirm Password\" size=\"30\" type=\"password\"> </div> <button class=\"btn btn-lg btn-red btn-block\" type=\"submit\"> Sign up </button> <h6 class=\"text-xs text-right\"> * By signing up you accept the EasyPost Terms of Service. </h6> </form> <div class=\"clearfix\"></div> </div> </div> </div> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/user_create.ejs
// module id = 875
// module chunks = 1